document.addEventListener('alpine:init', () => {
  Alpine.store('cart', {
    cart: window.sideCart.cart,
    items: []
  });

  Alpine.data('sidecart', () => ({
    isOpen: false,
    loading: false,
    cartSellingPlans: {},
    freeGiftThreshold: window.sideCart.settings.freeGiftThreshold,
    freeGiftVariantId: window.sideCart.settings.freeGiftVariantId,
    
    init() {
      this.fetchSellingPlans();

      if (PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (eventData) => {
          this.open();
          document.body.classList.add('rh-sidecart-open');
          this.loading = true;
          this.fetchCart();
        });
      }

      // Listen for cart updates
      window.addEventListener('cart:updated', (event) => {
          this.$store.cart.cart = event.detail.cart;
          this.$store.cart.items = event.detail.cart.items;
          this.fetchSellingPlans();
      });

      window.addEventListener('cart:refresh', (event) => {
        this.fetchCart();
      });
      
      
      // Listen for cart open events
      window.addEventListener('cart:open', () => {
        this.open();
      });
      
      // Add click listener for cart icon in header
      this.setupCartIconListener();
    },

    get cartItems(){
      let items = this.$store.cart.cart.items;

      if (items) {
        items.forEach(item => {
          const sellingPlans = this.cartSellingPlans[item.key];
          if (sellingPlans) {
            item.selling_plans = sellingPlans;
          }
        });
      }

      return items || [];
    },

    get totalSamplesInCart(){
      const freeSamples = window.freeSampleProducts || [];
      const cartItems = this.$store.cart.cart.items || [];
      return cartItems.reduce((total, item) => {
      const isSample = freeSamples.some(product => {
        const sampleVariantId = product.variants && product.variants[0] ? product.variants[0].id : product.id;
        return item.variant_id === sampleVariantId || item.product_id === product.id;
      });
      return isSample ? total + item.quantity : total;
      }, 0);
    },

    get remainingToFreeGift(){
      return this.formatMoney(this.freeGiftThreshold - this.$store.cart.cart.total_price);
    },

    get isFreeGiftEligible(){
      return this.$store.cart.cart.total_price >= this.freeGiftThreshold;
    },

    get isFreeGiftInCart(){
      return this.$store.cart.cart.items.some(item => 
        item.properties && 
        item.properties._widget === 'cart9202689gqp'
      );
    },

    captureSellingPlans(){
      const jsonScript = document.querySelector('#cart-selling-plans-data');
      const data = JSON.parse(jsonScript.textContent);
      this.cartSellingPlans = data;
    },
    
    setupCartIconListener() {
      // Wait for DOM to be fully loaded
      document.addEventListener('DOMContentLoaded', () => {
        const cartIcons = document.querySelectorAll('.header__icon--cart, .header__icon.header__icon--cart');
        
        cartIcons.forEach(icon => {
          icon.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.open();
          });
        });
      });
    },
    
    open() {
      document.body.classList.add('rh-sidecart-open');
      this.fetchCart();
      // Set isOpen after a tiny delay to ensure CSS transitions work properly
      setTimeout(() => {
        this.isOpen = true;
      }, 10);
    },
    
    close() {
      this.isOpen = false;
      setTimeout(() => {
        document.body.classList.remove('rh-sidecart-open');
      }, 300); // Match the transition duration
    },
    
    async fetchCart() {
      this.loading = true;
      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          this.$store.cart.cart = data;
          this.fetchSellingPlans();
          this.checkIfFreeGiftShouldBeRemoved();
        })
        .catch(error => console.error('Error fetching cart:', error))
        .finally(() => {
          this.loading = false;
        });
    },
    
    async updateItemQuantity(key, quantity) {
      quantity = parseInt(quantity);
      
      // Show immediate feedback by updating the local data first
      const itemIndex = this.$store.cart.items.findIndex(item => item.key === key);
      if (itemIndex !== -1) {
        if (quantity <= 0) {
          // Visually remove item from cart immediately
          this.$store.cart.items.splice(itemIndex, 1);
          if (this.$store.cart.items.length === 0) {
            this.$store.cart.item_count = 0;
          }
        } else {
          // Update the item quantity locally
          const oldQuantity = this.$store.cart.items[itemIndex].quantity;
          this.$store.cart.items[itemIndex].quantity = quantity;
          this.$store.cart.item_count = this.$store.cart.item_count - oldQuantity + quantity;
        }
      }
      
      // Then send the update to the server
      try {
        this.loading = true;
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        
        // Update with the server response to ensure accuracy
        this.$store.cart.cart = await response.json();
        this.loading = false;

        this.checkIfFreeGiftShouldBeRemoved();
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: this.$store.cart.cart } }));
      } catch (error) {
        console.error('Error updating item quantity:', error);
        // If there was an error, refresh the cart to ensure data is correct
        this.fetchCart();
      }
    },
    
    async removeItem(key) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        
        this.$store.cart.cart = await response.json();
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: this.$store.cart.cart } }));
      } catch (error) {
        console.error('Error removing item:', error);
      }
    },
    
    upgradeToSubscription(itemKey, selectedPlanId, quantity) {
      this.loading = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: itemKey,
          selling_plan: parseInt(selectedPlanId),
          quantity: quantity
        })
      })
      .then(res => res.json())
      .then(() => {
        this.fetchCart();
      })
      .finally(() =>{
        this.loading = false;
      })
    },
    
    formatMoney(cents) {
      return (cents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: window.sideCart.currencyIsoCode
      });
    },
    
    fetchSellingPlans() {
      fetch('/?section_id=cart-selling-plans')
        .then(res => res.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const jsonScript = tempDiv.querySelector('#cart-selling-plans-data');
          if (jsonScript) {
            this.cartSellingPlans = JSON.parse(jsonScript.textContent);
          }
        });
    },

    addFreeGiftToCart(){
      this.addToCart(this.freeGiftVariantId, {'_widget': 'cart9202689gqp'});
    },

    checkIfFreeGiftShouldBeRemoved(){
      if (this.isFreeGiftInCart && !this.isFreeGiftEligible) {
        // Remove the free gift from the cart
        const freeGiftItem = this.$store.cart.cart.items.find(item => 
          item.properties && 
          item.properties._widget === 'cart9202689gqp'
        );

        if (freeGiftItem) {
          this.removeItem(freeGiftItem.key);
        }
      }
    },

    addToCart(variantId, properties) {
      this.loading = true;

      let cartItems = [{
        id: variantId,
        quantity: 1
      }];

      if (properties) {
        cartItems[0].properties = properties;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: cartItems
        })
      })
      .then(res => res.json())
      .then(() => {
        this.fetchCart();
      })
      .finally(() => {
        this.loading = false;
      })
      .catch(error => console.error('Error adding free gift:', error));
    }
  }));

  function initCartSlider(container){
    new Splide('#splide-' + container, {
      perPage: 2,
      perMove: 1,
      pagination: false,
      arrows: false,
      rewind: false,
      gap: '.9rem',
      padding    : {
        right   : '2rem',
        left    : '0rem',
      },
      breakpoints: {
        1024: {
          perPage: 1,
          gap: '1.13rem',
        },
        640: {
          perPage: 1,
          padding    : {
            right   : '4rem',
            left    : '0rem',
          },
          gap: '1.12rem',
        },
      }
    }).mount();
  }

  Alpine.data('productRecommendations', () => ({
    recommendations: [],
    init() {
      this.fetchRecommendations();
    },

    fetchRecommendations() {
      // Get the first product from the cart store
      if (this.$store.cart.cart.items.length === 0) {
        return;
      }

      const firstProduct = this.$store.cart.cart.items[0];

      fetch('/recommendations/products?section_id=recommendations&product_id=' + firstProduct.product_id+ '&limit=4')
        .then(response => response.text())
        .then(async (responseHTML) => {
          //this.recommendations = data.products;
          //console.log('Data', data);
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = responseHTML;
          const recommendationsContainer = tempDiv.querySelector('#shopify-section-recommendations');
          if (recommendationsContainer) {
            document.querySelector('#product-recommendation-container').innerHTML = recommendationsContainer.innerHTML;

            this.$nextTick(() => {
              initCartSlider('recommendations');
            });
          }

        })
        .catch(error => console.error('Error fetching recommendations:', error));
    },
    addToCart(id){
      this.loading = true;

      let cartItems = [{
        id: id,
        quantity: 1
      }];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: cartItems
        })
      })
      .then(res => res.json())
      .then(() => {
        this.fetchCart();
      })
      .finally(() => {
        this.loading = false;
        // Emit cart:refresh
        window.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(error => console.error('Error adding free gift:', error));
    }
  }));


  Alpine.data('freeSampleProducts', () => ({
    products: window.freeSampleProducts,

    init(){
      this.$nextTick(() => {
        initCartSlider('freesamples');
      });
    },

    get freeSamplesInCart(){
      // Counts free sample products in the cart by comparing product IDs
      return this.$store.cart.cart.items
        .filter(cartItem => {
          // We need to check if any of the free sample products is in the cart
          return this.products.some(sampleProduct => {
            // Compare product IDs or variant IDs depending on what's available
            const sampleVariantId = sampleProduct.variants?.[0]?.id || sampleProduct.id;
            return cartItem.variant_id === sampleVariantId || cartItem.product_id === sampleProduct.id;
          });
        })
        .length;
    },

    addToCart(id){
      this.loading = true;

      let cartItems = [{
        id: id,
        quantity: 1
      }];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: cartItems
        })
      })
      .then(res => res.json())
      .then(() => {
        this.fetchCart();
      })
      .finally(() => {
        this.loading = false;
        // Emit cart:refresh
        window.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(error => console.error('Error adding free gift:', error));
    }
  }));

});

// DOM loaded
document.addEventListener('DOMContentLoaded', () => {
  // Check if there are any URL parameters indicating cart should be opened
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('open_cart') === 'true') {
    window.dispatchEvent(new CustomEvent('cart:open'));
  }
});